import { FC, ReactElement, useCallback, useState } from 'react';

import { updateBebyggelseobjektUtkast } from 'store/bebyggelseobjektUtkastSlice';
import { deleteUtkastSammansattReferens } from 'store/utkastSlice';

import { useAppDispatch } from 'hooks/defaultStoreHooks';
import { useDialog } from 'hooks/useDialog';

import { RaaDialog } from 'raa-react';

import { BebyggelseobjektUtkastIndex } from 'models';

import { useReserveBebyggelseutkastMutation } from 'api/endpoints/reservationSlice';

const DeleteIngaendeUtkastDialog: FC<BebyggelseobjektUtkastIndex> = ({
  utkast_id,
  sammansatt_parent_id
}): ReactElement => {
  const dispatch = useAppDispatch();
  const { unsetDialog } = useDialog();
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [patchReservation, results] = useReserveBebyggelseutkastMutation();
  const { isError: patchingReservationIsError } = results;

  const handleDelete = useCallback(async () => {
    if (!sammansatt_parent_id) return;

    setError(false);
    setIsLoading(true);
    await patchReservation({ id: utkast_id, reserve: true });

    if (patchingReservationIsError) {
      setIsLoading(false);
      setError(true);
    } else {
      const deleteResponse = await dispatch(
        deleteUtkastSammansattReferens({ utkast_id: sammansatt_parent_id, bebyggelseobjekt_id: utkast_id })
      );

      if (deleteResponse.meta.requestStatus === 'fulfilled') {
        setIsLoading(false);
        dispatch(updateBebyggelseobjektUtkast(utkast_id));
      } else {
        await patchReservation({ id: utkast_id, reserve: false });
        setError(true);
        setIsLoading(false);
      }
    }
    unsetDialog();
  }, [sammansatt_parent_id, patchReservation, utkast_id, patchingReservationIsError, unsetDialog, dispatch]);

  return (
    <RaaDialog
      cancel={unsetDialog}
      proceed={error ? undefined : handleDelete}
      close={!isLoading ? unsetDialog : undefined}
      header={error ? 'Något gick fel!' : 'Vill du radera det ingående utkastet?'}
      proceedButtonText="radera"
      cancelButtonText={error ? 'Stäng' : 'avbryt'}
      showLoadingSpinner={isLoading}
    />
  );
};

export default DeleteIngaendeUtkastDialog;
